/**
 * Чем зритель водил последним: клавиатурой (Tab, стрелки, пульт в браузере
 * телевизора) или указателем (мышь, палец).
 *
 * Нужно там, где «фокус» и «курсор» значат разное. Главная: наведение мыши
 * меняет тайтл наверху, но мягкий фон ниже слайдера за курсором не ходит
 * (правка владельца 05.10.2026 — «страница не должна размываться при
 * наведении мышкой»), а фокус с клавиатуры ведёт фон за собой, как пульт в
 * приложении. Событие фокуса само не говорит, чем его вызвали: щелчок мышью
 * тоже ставит фокус. Поэтому помним последний ввод.
 */
export type InputVia = 'keyboard' | 'pointer';

let last: InputVia = 'pointer';
let installed = false;

const POINTER_EVENTS = ['pointerdown', 'pointermove', 'wheel', 'touchstart'] as const;

function install(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  window.addEventListener(
    'keydown',
    (event) => {
      // Сочетания (Ctrl+C, Alt+Tab) — не навигация по странице.
      if (!event.metaKey && !event.ctrlKey && !event.altKey) last = 'keyboard';
    },
    true,
  );
  for (const type of POINTER_EVENTS) {
    window.addEventListener(type, () => {
      last = 'pointer';
    }, { capture: true, passive: true });
  }
}

/** Начать следить за вводом (один раз на вкладку; повторные вызовы ничего не делают). */
export function watchInput(): void {
  install();
}

/** Последний ввод зрителя; пока он ничего не трогал — указатель. */
export function lastInput(): InputVia {
  install();
  return last;
}
